module.exports = __webpack_public_path__ + "img/about/80243-017.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-017.png
// module id = 27
// module chunks = 0